"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // GlobalError renders outside the locale tree (no next-intl context). Pick
  // copy + lang from the URL so DE users don't get English on a crash.
  const isDe =
    typeof window !== "undefined" && window.location.pathname.startsWith("/de");
  const copy = isDe
    ? {
        lang: "de",
        heading: "Etwas ist schiefgelaufen!",
        retry: "Erneut versuchen",
      }
    : { lang: "en", heading: "Something went wrong!", retry: "Try again" };

  return (
    <html lang={copy.lang}>
      <body>
        <h2>{copy.heading}</h2>
        <pre>{error.message}</pre>
        <button onClick={() => reset()}>{copy.retry}</button>
      </body>
    </html>
  );
}
